import {
    createClickableLink,
} from "../../../../components/common/datatable/DataTableUtils"
import React, { useEffect, useMemo, useState } from "react";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { useSelector } from "react-redux";
import {
    SearchDatePickerWrapper
} from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { SearchSelectWithEnum } from "../../../../components/common/datatable/filter/SearchSelectWrapper"
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useSearchImportVersionsQuery, useLazyExportImportVersionsDataQuery } from "../importVersionApi";
import { formatValueAsDateAndTime } from "../../../../helpers/utils/DateUtils";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import CollectorSearchInputWrapper from "../../../../components/common/datatable/filter/CollectorSearchInputWrapper";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";

const ImportVersion = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Import Version");
    const [triggerExportImportVersionsDataQuery] = useLazyExportImportVersionsDataQuery();
    const [showCollector, setShowCollector] = useState(false);
    const [collectorValue, setCollectorValue] = useState([]);
    const [collectorTagValue, setCollectorTagValue] = useState([]);
    const { data: enums } = useGetEnumsQuery("");
    useEffect(() => {
        document.title = 'Import Version';
    }, []);


    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Import Versions", url: "" }]
    )

    let filterModalOptions = [
        {
            filterModalKey: "id",
            filterModalKeyAccessor: "collectorIds",
            showModal: showCollector,
            setShowModal: setShowCollector,
            showModalValue: collectorValue,
            setShowModalValue: setCollectorValue,
            showModalTagValue: collectorTagValue,
            setShowModalTagValue: setCollectorTagValue,
            isMultiSelect: true,
        }];

    const columns: DataTableColumn[] = [
        {
            label: "Collector",
            accessor: "collectorName",
            visibility: { hasShowSetting: false },
            cell: (props: any) => {
                let path = "/collectors/" + props.row.original.collectorId;
                return createClickableLink(path, props.row.original.collectorName, userSetting, false, "", ["COLL-R"]);
            },
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorId" />,
                overrideFilterAccessor: "collectorIds",
                overrideFilterLabel: "Collector",
            }]
        },
        {
            label: "Tax Year", accessor: "taxYear",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"number"} placeholder={"Enter Tax Year..."} name={"taxYear"}
                    accessor={"taxYear"} />,
            }],
        },
        {
            label: "Data File Type", accessor: "dataFileType",
            cell: (props: any) => getEnumDisplayNameByConstant(enums?.["DataFileType"], props.value),
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["DataFileType"], "Select Data File Type...", false, "dataFileType"),
                overrideFilterLabel: "Data File Type",
            }],
        },
        {
            label: "As Of Date", accessor: "asOfDate",
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.asOfDate);
            },
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"asOfDateFrom"} />,
                overrideFilterAccessor: "asOfDateFrom",
                overrideFilterLabel: "As Of Date - From",
            },
            {
                filterComponent: <SearchDatePickerWrapper accessor={"asOfDateTo"} />,
                overrideFilterAccessor: "asOfDateTo",
                overrideFilterLabel: "As Of Date - To",
            }],
        },
        {
            label: "Activation Date", accessor: "activationDate",
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.activationDate);
            },
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"activationDateFrom"} />,
                overrideFilterAccessor: "activationDateFrom",
                overrideFilterLabel: "Activation Date - From",
            },
            {
                filterComponent: <SearchDatePickerWrapper accessor={"activationDateTo"} />,
                overrideFilterAccessor: "activationDateTo",
                overrideFilterLabel: "Activation Date - To",
            }],
        },
        {
            label: "Record Count", accessor: "recordCount",
        }
    ]


    const selector = (state: any) => state.getAllImportVersionsReducer;

    return (
        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchImportVersionsQuery,
                    exportAction: triggerExportImportVersionsDataQuery
                }}
                userSettingGroup={"Import Version"}
                basePermission={"DATARETVAL"}
                
            />

        </div>

    );
};
export default ImportVersion;
